import slugify from 'slugify'
import { useStoreState } from '@/store'
import { getHostURL } from '@/utils/seo'

const host = getHostURL(process.env.NEXT_PUBLIC_APP_ENV)

const getUrl = (city, state) => {
    return `${host}/real-estate/agents/${slugify(state).toLowerCase()}/${slugify(city).toLowerCase()}/`
}

const NearbyLocations = ({ showHeading = true, hideOnNoResults }: {showHeading?: boolean, hideOnNoResults: boolean}) => {
  const { locationsNearbyResponse, totalResults } = useStoreState(
    state => state.search
  )

  if (!locationsNearbyResponse) {
    return null
  }

  if (hideOnNoResults && !totalResults) {
    return null
  }

  return (
    <section id="nearby-locations">
      {showHeading ? <h3 className="type-heading-six uppercase my-6">
        Find Agents and Realtors near {locationsNearbyResponse.origin.city},{' '}
        {locationsNearbyResponse.origin.state}
      </h3> : null}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 mt-6 gap-6 gap-y-6">
        {locationsNearbyResponse.nearby_locations.map((location, index) => {
          return (
            <div
              key={index}
              className="ArticleRecommendedCard Card Card--accentedBottom"
            >
              <article className="Card-body">
                <div className="my-0">
                  <h2 className="type-heading-four text-crop-none mb-4 mt-0">
                    <a className="Card-link" href={getUrl(location.city, location.state_abbr)}>
                      {location.city}, {location.state_abbr} Real Estate Agents
                      & Realtors
                    </a>
                  </h2>
                </div>
              </article>
            </div>
          )
        })}
      </div>
    </section>
  )
}

export default NearbyLocations
